import PatientOutcomesContainer from './PatientOutcomes.container';
export default PatientOutcomesContainer;
